/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShippingData
 */
export interface ShippingData {
    /**
     * 
     * @type {string}
     * @memberof ShippingData
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingData
     */
    amount?: number;
}

/**
 * Check if a given object implements the ShippingData interface.
 */
export function instanceOfShippingData(value: object): value is ShippingData {
    return true;
}

export function ShippingDataFromJSON(json: any): ShippingData {
    return ShippingDataFromJSONTyped(json, false);
}

export function ShippingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingData {
    if (json == null) {
        return json;
    }
    return {
        
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function ShippingDataToJSON(json: any): ShippingData {
    return ShippingDataToJSONTyped(json, false);
}

export function ShippingDataToJSONTyped(value?: ShippingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remoteId': value['remoteId'],
        'name': value['name'],
        'amount': value['amount'],
    };
}

